import { ReactNode } from "react";

const Note = ({
  title,
  description,
  cardClassname = "",
  titleClassname = "",
  descriptionClassname = "",
}: {
  title: ReactNode;
  description: ReactNode;
  cardClassname?: string;
  titleClassname?: string;
  descriptionClassname?: string;
}) => {
  return (
    <div
      className={`p-4 pl-[14px] border-l-2 flex flex-col gap-2.5 font-inter bg-[#EAA13B1F] border-warning ${cardClassname}`}
    >
      <h3
        className={`text-xl text-white font-semibold leading-[26px] ${titleClassname}`}
      >
        {title}
      </h3>
      <p className={`leading-5 text-base text-[#EAA13B96] ${descriptionClassname}`}>
        {description}
      </p>
    </div>
  );
};

export default Note;
